import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { API_PATH } from 'common/constants/services';
import useMutation, { METHOD } from 'hook/useMutation';
import useQuery from 'hook/useQuery';
import PartsList from 'pages/parts/PartsList';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

interface IProps {
  isOpen: boolean;
  onSuccess: () => void;
  close: () => void;
}

interface IFormValue {
  workoutsText: string;
}

type TMutation = Omit<Part, 'id'> & { part_id: number };

export function WorkoutInsertModal({ isOpen, onSuccess, close }: IProps) {
  const { register, getValues, reset } = useForm<IFormValue>();
  const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [selectedParts, setSelectedParts] = useState(1);

  const handleCloseModal = () => {
    close();
  };

  const partQuery = useQuery<PartResponse>(API_PATH.PARTS);
  const insertWorkoutQuery = useMutation<TMutation>(API_PATH.WORKOUTS, {
    method: METHOD.POST,
    onSuccess: () => {
      toast.success('등록이 완료되었습니다.');
      reset();
      onSuccess();
    },
  });
  const onClickSave = () => {
    if (window.confirm('등록하시겠습니까?')) {
      const { workoutsText } = getValues();

      insertWorkoutQuery.mutate({
        part_id: selectedParts,
        name: workoutsText,
        display_order: null,
      });
    }
  };

  useEffect(() => {
    if (
      partQuery.getQuery.data?.data.results &&
      partQuery.getQuery.data?.data.results.length > 0
    ) {
      setSelectedParts(partQuery.getQuery.data?.data.results[0].id);
    }
  }, [partQuery, setSelectedParts]);

  return (
    <Dialog
      keepMounted
      open={isOpen}
      onClose={handleCloseModal}
      aria-labelledby='keep-mounted-modal-title'
      aria-describedby='keep-mounted-modal-description'
    >
      <DialogContent>
        <PartsList
          selectedParts={selectedParts}
          setSelectedParts={setSelectedParts}
          input={inputRef}
          parts={partQuery.getQuery.data?.data.results || []}
          size='small'
        />
        <Box
          sx={{
            width: { xs: '100%', md: '50%' },
          }}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <TextField
              fullWidth
              type='text'
              placeholder='workout'
              inputRef={inputRef}
              {...register('workoutsText', { required: true })}
              autoFocus
            />
          </form>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCloseModal}>
          취소
        </Button>
        <Button variant='contained' color='success' onClick={onClickSave}>
          등록
        </Button>
      </DialogActions>
    </Dialog>
  );
}
